import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface InfoFieldProps {
  label: string
  className?: string
  valueClassName?: string
  children: React.ReactNode
}

export function InfoField({
  label,
  className,
  valueClassName,
  children,
}: InfoFieldProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <Label className="text-muted-foreground text-sm">{label}</Label>
      <div className={cn('text-md font-medium', valueClassName)}>
        {children}
      </div>
    </div>
  )
}
